var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19a1 1 0 100-2 1 1 0 000 2z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 22c1.48 0 2.773-.804 3.465-2H20a2 2 0 100-4h-2.535A3.998 3.998 0 0014 14c-1.48 0-2.773.804-3.465 2H4a2 2 0 100 4h6.535A3.998 3.998 0 0014 22zm0-1.25a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zm6-2h-2.07a4.02 4.02 0 000-1.5H20a.75.75 0 010 1.5zm-16-1.5h6.07a4.02 4.02 0 000 1.5H4a.75.75 0 010-1.5z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "#ADC9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7a1 1 0 100-2 1 1 0 000 2z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10c1.48 0 2.773-.804 3.465-2H20a2 2 0 100-4h-6.535A3.998 3.998 0 0010 2c-1.48 0-2.773.804-3.465 2H4a2 2 0 100 4h2.535A3.998 3.998 0 0010 10zm0-1.25a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zm10-2h-6.07a4.02 4.02 0 000-1.5H20a.75.75 0 010 1.5zM4 5.25h2.07a4.02 4.02 0 000 1.5H4a.75.75 0 010-1.5z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3c6ab0e9951b5cf4095758b77604a656.svg";
export { ForwardRef as ReactComponent };